import { gql } from "@apollo/client";

const partner = ` 
     _id
      partnerName
      primaryContactName
      type
      partnerLogo
      email
      phoneNumber
      billingInfo {
        companyName
        address
        trn
        paymentTerms
        bankName
        bankAccount
      }
      countryInfo {
        countryCode
        isActive
      }
      isVerified
      status
      lastInteractionDate
      statementDays
      createdAt
      updatedAt
      rewards{
        rewardTypeId
        isActive
        createdAt
        updatedAt
        contractStartDate
        contractEndDate
        report{
          issued
          hold
          redeemed
          confirmed
          expired
        }
      }
`;

export const CREATE_NEW_PARTNER = gql`
  mutation CREATE_NEW_PARTNER($input: CreatePartnerInput!) {
    createNewPartner(input: $input) {
        ${partner}
    }
  }
`;

export const GET_PARTNER_DETAILS = gql`
  query GET_PARTNER_DETAILS{
    getPartnerDetails{
        ${partner}
    }
  }
`;

export const GET_PARTNER_CAMPAIGNS = gql`
  query GET_PARTNER_CAMPAIGNS($input: PartnerCampaignListInput!) {
    getPartnerCampaigns(input: $input) {
      currentOffset
      totalCount
      totalPages
      campaigns {
        promotionId
        promotionName
        launcherId
        launcherName
        rewardSummary {
          contributionPoints
          rewardTypeId
        }
        launcher {
          name
          startDate
          endDate
          neverExpires
        }
        contributionAmount
        createdAt
      }
    }
  }
`;

export const GET_PARTNER_STATEMENTS = gql`
  query GET_PARTNER_STATEMENTS($input: PartnerStatementListInput!) {
    getPartnerStatements(input: $input) {
      statements {
        statementRef
        issuerId
        issuerName
        recipientId
        recipientName
        amount
        fromDate
        toDate
        countryCode
        statementPeriodId
      }
      totalPages
      totalCount
      pageOffset
    }
  }
`;

export const GET_PARTNER_TRANSACTIONS = gql`
  query GET_PARTNER_TRANSACTIONS($input: PartnerTransactionListInput!) {
    getPartnerTransactions(input: $input) {
      transactions {
        transactionId
        transactionType
        issuerPartyId
        receiverPartyId
        countryCode
        statementPeriodId
        rewardTypeId
        launcherId
        transactionValue
        rewardValue
        isVatInclusive
        vatRate
        vat
        description
        createdAt
        orderId
      }
      totalPages
      totalCount
      pageOffset
    }
  }
`;

export const UPDATE_PARTNER_DETAILS = gql`
  mutation UPDATE_PARTNER_DETAILS($input: UpdatePartnerInput!) {
    updatePartnerDetails(input: $input) {
        ${partner}
    }
  }
`;

export const GET_PARTNER_REDEMPTIONS = gql`
  query GET_PARTNER_REDEMPTIONS($input: PartnerRedemptionsInput!) {
    getPartnerRedemptions(input: $input) {
      currentOffset
      totalCount
      totalPages
      redemptions {
        redemptionId
        transactionRef
        finalValue
        subTotal
        totalDiscount
        status
        partnerId
        totalPoints
        contributionPoints
        rewardTypeId
        contributionAmount
        createdAt
        countryCode
        totalPointsInAmount
        contributionPointsInAmount
        totalEligiblePrice
      }
    }
  }
`;
